<template>
  <section class="donor-list">
    <div class="home-page-limestone">
      <div class="container">
        <div class="row align-items-end">
          <div class="col-12">
            <div class="section-heading">
              <h2 class="entry-title">รายนามผู้บริจาค</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 col-sm-12">
            <div class="card">
              <div class="card-header bg-info d-sm-flex justify-content-between border-0 pb-0">
                <h5 class="card-title p-2">
                  <font-awesome-icon :icon="['fas', 'donate']" /> รายชื่อผู้บริจาคล่าสุด
                  <a :href="'/donors'" class="btn btn-sm btn-outline-primary" role="button">
                    <font-awesome-icon :icon="['fas', 'search']" style="color: #0656e0" />
                    ค้นหา
                  </a>
                </h5>
              </div>
              <div class="card-body">
                <div class="row g-4">
                  <div v-for="item in donors.slice(0, 20)" :key="item.DONATEID" class="col-md-6 col-sm-6">
                    <div class="border rounded-3 p-3 donate-info">
                      <div class="donor-name">
                        {{ replaceSpecialCharacters(item.PREFIX) }}{{ item.NAME }}
                        {{ replaceSpecialCharacters(item.SURNAME) }}
                      </div>
                      <div class="campaign-title">บริจาคโครงการ {{ item.TITLE }}</div>
                      <div class="d-flex justify-content-between">
                        <div>
                          จำนวน
                          <span class="donate-amount">{{ formatPrice(item.AMOUNT) }}</span> บาท
                        </div>
                        <div class="group-name">{{ item.GROUP_NAME }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="card">
              <div class="card-header bg-info d-sm-flex justify-content-between border-0 pb-0">
                <h5 class="card-title p-2">
                  <font-awesome-icon :icon="['fas', 'donate']" /> รายชื่อผู้บริจาคพรีเมี่ยม
                </h5>
              </div>
              <div class="card-body">
                <div class="row g-4">
                  <div
                    v-for="item in donorsPremium.slice(0, 20)"
                    :key="item.DONATEID"
                    class="col-md-12 col-sm-12"
                  >
                    <div class="border rounded-3 p-3 donate-info">
                      <div class="donor-name">
                        {{ replaceSpecialCharacters(item.PREFIX) }}{{ item.NAME }}
                        {{ replaceSpecialCharacters(item.SURNAME) }}
                      </div>
                      <div class="campaign-title">บริจาคโครงการ {{ item.TITLE }}</div>
                      <div class="d-flex justify-content-between">
                        <div>
                          จำนวน
                          <span class="donate-amount">{{ formatPrice(item.AMOUNT) }}</span> บาท
                        </div>
                        <div class="group-name">{{ item.GROUP_NAME }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { formatPrice, replaceSpecialCharacters } from '../scripts/utillities';
import { useDonors } from '../scripts/useDonors';

const { donors, donorsPremium } = useDonors();
</script>

<style scoped>
.donate-info {
  font-size: 0.9rem;
}
.donor-name {
  font-weight: bold;
}
.campaign-title {
  font-weight: 400;
}
.donate-amount {
  font-weight: bold;
  color: #e02f2f;
}
.group-name {
  font-weight: 400;
}
</style>